
export default {
  name: 'Placeholder'
}
